import api from '@/api'
import BrandRequest from '@/model/brand/BrandRequest'
import BrandSearchRequest from '@/model/brand/BrandSearchRequest'
import AffiliateRequest from '@/model/affiliate/AffiliateRequest';

export default {
  namespaced: true,
  state: {
    statusIds: []
  },
  getters: {
    statusIds: state => state.statusIds,
    statusById: state => id => state.statusIds.find(status => status.id === id)
  },
  mutations: {
    updateData(state, data) {
    }
  },
  actions: {
    refreshData({ commit }) {
      return api.base()
        .get('/brand/data')
        .then(
          response => {
            commit('updateData', response.data.data);
          }
        );
    },
    getAllBrands(actions, {filter,pagination,sort}) {
      return api.base()
        .post('/brand/get/all',
          BrandSearchRequest( { ...(filter || {}), pagination, sort, })
        )
        .then(response => ({
            data: response.data.data,
            pagination: { page: response.data.metadata.page, total: response.data.metadata.total},
            sort: response.data.metadata.sort
          })
        )
    },
    getAll(actions) {
      return api.base()
        .get('/brand/all'
        )
        .then(response => ({
            data: response.data.data,
          })
        )
    },
    getBrandById({ commit }, id) {
      return api.base()
        .get('/brand/id/' + id)
        .then(
          response => {
            return response.data.data
          }
        )
    },
    togglePlayingAction({ commit }, { id, action }) {
      return api.base()
        .post('/brand/toggle-playing/' + id,action )
        .then(
          response => {
            return response.data.data
          }
        )
    }
,
    createBrand({ commit }, { brand }) {
      return api.base()
        .post('/brand/add', BrandRequest(brand))
        .then(
          response => {
            return response.data.data;
          }
        );
    },
    updateBrand({ commit }, { brand, id }) {
      return api.base()
        .post('/brand/update/'+id, BrandRequest(brand))
        .then(
          response => {
            return response.data.data
          }
        )
    }
  },
}
